export const presence = [
    {
        title: "Creative AI Approach",
        discription: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.Quas, perferendis. Cumque nam voluptatem eum sequi!",
        persantine: "85%",
        number: 1
    },
    {
        title: "Guaranteed Success",
        discription: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.Quas, perferendis. Cumque nam voluptatem eum sequi!",
        persantine: "60%",
        number: 2
    }, {
        title: "AI Brand Strategy",
        discription: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.Quas, perferendis. Cumque nam voluptatem eum sequi!",
        persantine: "70%",
        number: 3
    },
]
